import constants from '@/utils/constants';

export function getOptimizedImageSrc(src, size) {
  if (!src) return constants.placeholderImage;
  if (shouldIgnoreOptimization(src)) return src;

  if (!['small', 'medium', 'large'].includes(size)) {
    throw new Error('Image size not supported');
  }

  if (src.includes(`${size}-kar`)) return src;

  return src.replace(/(.*)\/(.*)?$/, `$1/${size}-kar/$2`);
}

// If either local asset, svg or base64 - don't optimize
const shouldIgnoreOptimization = (src) => {
  return /^\/img\/|\.svg$|^data:image\/[a-zA-Z0-9+]+;base64/.test(src);
};

function getSize(el) {
  if (el.width < 250) return 'small';
  if (el.width < 500) return 'medium';
  return 'large';
}

const processOptimizedSrc = (el, binding) => {
  const DEFAULT_BLUR_SRC = '/img/blurhash.png';

  const params = binding.value || {};
  const isLazy = params.lazy || false;
  const size = params.size || getSize(el);

  const optimizedImage = shouldIgnoreOptimization(params.src)
    ? params.src
    : getOptimizedImageSrc(params.src, size);

  if (!isLazy) {
    el.setAttribute('src', optimizedImage);
    return;
  }

  el.setAttribute('data-src', optimizedImage);
  el.setAttribute('src', DEFAULT_BLUR_SRC);

  const options = {
    root: document.getElementsByClassName('route-wrapper')[0],
    rootMargin: '300px',
  };

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const lazyImage = entry.target;
        if (lazyImage.dataset.src) {
          lazyImage.src = lazyImage.dataset.src;
          imageObserver.unobserve(el);
        }
      }
    });
  };

  const imageObserver = new IntersectionObserver(callback, options);

  imageObserver.observe(el);
};

export default {
  mounted(el, binding) {
    processOptimizedSrc(el, binding);
  },
  updated(el, binding) {
    processOptimizedSrc(el, binding);
  },
};
